import makeStyles from '@ui/utils/makeStyles';

interface TextMediaStyleProps {
  orientation?: 'left' | 'right';
}

export default makeStyles<TextMediaStyleProps>()((theme, { orientation }) => ({
  textMediaWrapper: {
    background: theme.palette.common.white,
    minHeight: 750,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    margin: theme.spacing(0),
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(8, 0),
    }
  },
  textWrapper: {
    width: '100%',
    padding: theme.spacing(3, 2),
    display: 'flex',
    flexDirection: 'column',
    order: 2,
    '& .MuiTypography-overline': {
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(10),
      }
    },
    '& .MuiTypography-body1': {
      flex: 1,
      fontSize: 16,
      lineHeight: 1.5,
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        fontSize: 24,
      }
    },
    [theme.breakpoints.up('md')]: {
      padding: '90px 80px',
      width: '50%',
      order: 'unset',
    }
  },
  mediaWrapper: {
    width: '100%',
    position: 'relative',
    order: 1,
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      [theme.breakpoints.up('md')]: {  
        position: 'relative',
        top: -90,
        borderRadius: theme.shape.borderRadius,
      }
    },
    [theme.breakpoints.up('md')]: {
      padding: orientation === 'left' ? `0 0 0 ${80}px` : `0 ${80}px 0 0`,
      width: '50%',
      order: 'unset',
    }
  },
  mediaWrapperInner: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  mediaCaption1Left: {
    position: 'absolute',
    left: '-15px',
    transform: 'rotateZ(-90deg)',
    transformOrigin: 'left',
    width: '100%',
    color: '#8a8e8e',
    bottom: 0,
    [theme.breakpoints.up('md')]: {
      bottom: 80,
    },
    '& a': {
      color: '#8a8e8e',
      textDecoration: 'none',
    }
  },
  mediaCaption2Left: {
    position: 'absolute',
    bottom: 0,
    left: '-15px',
    transform: 'rotateZ(-90deg)',
    transformOrigin: 'left',
    width: '100%',
    color: '#8a8e8e',
    display: 'flex',
    justifyContent: 'flex-end',
    '& a': {
      color: '#8a8e8e',
      textDecoration: 'none',
    }
  },
  mediaCaption1Right: {
    'top': '0',
    'left': 'calc(100% + 15px)',
    'color': '#8a8e8e',
    'position': 'absolute',
    'transform': 'rotateZ(90deg)',
    'transformOrigin': 'left',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      paddingLeft: 90,
    },
    '& a': {
      color: '#8a8e8e',
      textDecoration: 'none',
    }
  },
  mediaCaption2Right: {
    position: 'absolute',
    'left': 'calc(100% + 15px)',
    'transform': 'rotateZ(90deg)',
    transformOrigin: 'left',
    paddingRight: '100px',
    color: '#8a8e8e',
    boxSizing: 'content-box',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    '& a': {
      color: '#8a8e8e',
      textDecoration: 'none',
    },
    
  }
}));
